export default __webpack_public_path__ + "static/media/kit_1.8a4c038d.png";